import {
    Date as ProtoDate,
    Date as LsqDate
} from '@lsq-frontend/remote-services/all-java/common-mk0';
/**
 * The back end uses protobuf heavily to construct the data it sends us. "Null" is not a thing in
 * proto — rather, empty values are replaced with the default for that data type. In the case of
 * `Timestamps`, the default is 1970, for which `Date.parse()` returns `0`. Since the back end
 * may or may not choose to override proto's opinion with truly empty fields, we also want to
 * account for that by testing for an empty value.
 *
 * @see https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.Timestamp
 */
export function isNotNullOrProtoDefault(maybeDate?: string): boolean {
    return maybeDate !== '' && maybeDate != null && Date.parse(maybeDate) !== 0;
}

export function parseDateIntoMonthDayYear(date: Date): ProtoDate {
    return {
        month: date.getMonth() + 1,
        day: date.getDate(),
        year: date.getFullYear()
    };
}

export function parseMonthDayYearIntoDate(date: ProtoDate): Date {
    return new Date(date.year, date.month - 1, date.day);
}

export function parseYearMonthDayStringToDate(dateString: string): Date {
    const [year, month, day] = dateString.split('-');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
}
